<template>
  <svg width="52" height="60" viewBox="0 0 52 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0081 59.0083C5.68959 61.6471 0 58.7108 0 53.8433V6.15673C0 1.2892 5.68959 -1.6471 10.0081 0.991722L49.0285 24.835C52.9905 27.256 52.9905 32.744 49.0285 35.165L10.0081 59.0083Z"
      fill="white"
    />
  </svg>
</template>
